/**
 * RFID card UID helpers. The RC522 returns a 4- or 7-byte UID; we store it as an
 * uppercase hex string with no separators (e.g. "04A1B2C3") so it compares
 * cleanly regardless of how the firmware formatted it.
 */
export function normalizeCardUid(raw: string): string {
  return raw.replace(/[^0-9a-fA-F]/g, '').toUpperCase();
}

/** Display form, byte-grouped: "04A1B2C3" → "04 A1 B2 C3". */
export function formatCardUid(uid: string): string {
  const clean = normalizeCardUid(uid);
  return clean.match(/.{1,2}/g)?.join(' ') ?? clean;
}

export function isValidCardUid(uid: string): boolean {
  const clean = normalizeCardUid(uid);
  return clean.length >= 8 && clean.length % 2 === 0;
}

/** A plausible random UID for mock-mode enrolment demos. */
export function randomCardUid(): string {
  const byte = () =>
    Math.floor(Math.random() * 256)
      .toString(16)
      .padStart(2, '0');
  return `04${byte()}${byte()}${byte()}`.toUpperCase();
}
